import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const variants = cva('inline-flex items-center rounded-md px-2 py-1 text-[11px] font-semibold', {
  variants: {
    variant: {
      secondary: 'bg-secondary text-secondary-foreground',
      success: 'bg-success/12 text-success',
      destructive: 'bg-destructive/12 text-destructive',
      warning: 'bg-warning/12 text-warning',
      outline: 'border border-border text-muted-foreground',
    },
  },
  defaultVariants: { variant: 'secondary' },
});

export function Badge({ className, variant, ...props }: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof variants>) {
  return <span className={cn(variants({ variant }), className)} {...props} />;
}
